import React, { Component } from "react";
import { getScenarioCatalogueInfo } from "../components/UserFunctions";
import { connect } from "react-redux";
import { addScenarioManagerFromAPI } from "../actions/scenarioManagerAction"
import ScenarioCatalogueTable from "../components/ScenarioCatalogueTable"
import Pagination from "../components/Pagination";
import PropTypes from 'prop-types';

class ScenarioManager extends Component {
//    constructor(props){
//        super(props)
//    }
//
    componentDidMount() {
        getScenarioCatalogueInfo(1).then(response => {
            if(response){
                this.props.dispatch(addScenarioManagerFromAPI(response))
            } else{
                this.props.dispatch(addScenarioManagerFromAPI({scenarioCatalogue: [],
                                                                pages: [],
                                                                currentPage: 0}))
            }
        })
    }


    render() {
        return(
            <div data-test = 'containerScenarioManagerComponent' className="container-fluid">
                <div className="row">
                  <div className="mt-5 mx-auto">
                    <div className="card" style={{backgroundColor: "white"}}>
                        <div className="card">
                            <h1 className="card-header" style={{color:"white", fontSize: "100% !important", backgroundColor: "#757AF7"}}>Scenario Catalogue</h1>
                        </div>
                            <div className="card-body">
                                <div className="table col-md-6 mx-auto">
                                    <ScenarioCatalogueTable
                                        scenarioCatalogueData={this.props.scenarioCatalogueData}
                                    />
                                </div>
                            </div>
                      </div>
                  </div>
                </div>
                <div>
                    {this.props.scenarioCatalogueData.length > 0 ?
                     <Pagination
                        currentPage={this.props.currentPage}
                        pages={this.props.pages}
                        getApiInfo={getScenarioCatalogueInfo}
                        action={addScenarioManagerFromAPI}
                     />
                     : undefined}
                </div>
              </div>
        )
    }
}
ScenarioManager.propTypes={
pages:PropTypes.string,
currentPage:PropTypes.string,
dispatch:PropTypes.string,
scenarioCatalogueData:PropTypes.string,
}
ScenarioManager.defaultProps= {
pages:[],
currentPage:[],
dispatch:[],
scenarioCatalogueData:[],
}

const mapStateToProps = (state) => {
    return {
        scenarioCatalogueData: state.scenarioCatalogue.scenarioCatalogue,
        currentPage: state.scenarioCatalogue.currentPage,
        pages: state.scenarioCatalogue.pages
    }
}
//file:index.js
//import necessary dependencies
//function:configureStore

export default connect(mapStateToProps)(ScenarioManager);
